import { useEffect, useState, useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";
import { getErrorMessage } from "@/lib/errors";

export interface FounderMetrics {
  generated_at: string;
  acquisition: Record<string, number | null>;
  activation: Record<string, number | null>;
  engagement: Record<string, number | null>;
  referral: Record<string, number | null>;
  content: Record<string, number | null>;
  ai: Record<string, number | null>;
  revenue: Record<string, number | string | null>;
  derived: Record<string, number | null>;
}

export function useFounderMetrics() {
  const [data, setData] = useState<FounderMetrics | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const { data: res, error: err } = await supabase.functions.invoke("founder-metrics");
      if (err) throw err;
      if ((res)?.error) throw new Error((res).error);
      setData(res as FounderMetrics);
    } catch (e: unknown) {
      setError(getErrorMessage(e) || "Failed to load metrics");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void load();
  }, [load]);

  return { data, loading, error, refetch: load };
}
